$mol_example_large $mol_example
